<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="企业名称" prop="name" >
        {{form.name}}
      </a-form-model-item>
      <a-form-model-item label="统一社会信用代码" prop="usci" >
        {{form.usci}}
      </a-form-model-item>
      <a-form-model-item label="法人姓名" prop="iegalName" >
        {{form.iegalName}}
      </a-form-model-item>
      <a-form-model-item label="LOGO" prop="logo" >
        <img v-if="form.logo" :src="form.logo" alt="LOGO"
             style="height:173px;width:173px"/>
      </a-form-model-item>
      <a-form-model-item label="行业名称" prop="industryName" >
        {{form.industryName}}
      </a-form-model-item>
      <a-form-model-item label="城市" prop="city" >
        {{form.city}}
      </a-form-model-item>
      <a-form-model-item label="公司介绍" prop="introduction" >
        {{form.introduction}}
      </a-form-model-item>
      <a-form-model-item label="官网地址" prop="webUrl" >
        {{form.webUrl}}
      </a-form-model-item>
<!--      <a-form-model-item label="认证状态" prop="status" >-->
<!--        <a-select v-model="form.status">-->
<!--          <a-select-option :key="1">-->
<!--            认证成功-->
<!--          </a-select-option>-->
<!--          <a-select-option :key="2">-->
<!--            认证失败-->
<!--          </a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <div class="bottom-control">-->
<!--        <a-space>-->
<!--          <a-button type="primary" :loading="submitLoading" @click="submitForm">-->
<!--            保存-->
<!--          </a-button>-->
<!--          <a-button type="dashed" @click="cancel">-->
<!--            取消-->
<!--          </a-button>-->
<!--        </a-space>-->
<!--      </div>-->
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCompany, addCompany, updateCompany } from '@/api/user/company'

export default {
  name: 'AuditDetailCompany',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        usci: null,

        iegalName: null,

        status: 0,

        logo: null,

        industryName: null,

        city: null,

        introduction: null,

        webUrl: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        usci: null,
        iegalName: null,
        status: 0,
        logo: null,
        industryName: null,
        city: null,
        introduction: null,
        webUrl: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    handleOpen(record) {
      // this.form.auditMessage = '';
      this.form.id = record.id;
      this.handleUpdate(null ,record.id);
      this.open = true;
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCompany({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '公司详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCompany(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCompany(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
